// extracted by mini-css-extract-plugin
export default {"container":"video_container__3QN23"};